import React, { useMemo, useRef } from 'react';
import SingleFooter from '../components/SingleFooter/SingleFooter';
import SingleHeader from '../components/SingleHeader/SingleHeader';
import SingleBreadcrumbs from '../../../widgets/breadcrumbs/SingleBreadCrumbs';
import Language from '../../../common/decorators/Language';
import uikit from '../../../project/uikit/uikit.module.scss';
import PropTypes from 'prop-types';
import SeoData from '../../../widgets/seoData/SeoData';
import css from './single.module.scss';
import AuthExternal from '../../../common/decorators/AuthExternal';
import classNames from 'classnames';
import { checkBrowser, useRouteAnimation } from '../../../common/utils/utils';
import AuthModal from '../../../widgets/authModal/AuthModal';

const Single = ({
    children,
    smallFooter,
    breadcrumbs,
    translates,
    title,
    seoData,
    disabledTransition,
    canonical,
    alias,
    errorPage,
    beforeHeaderRef,
    viewMoveUpBtn,
    compStyles,
    OverFooter,
    officeBg = false
}) => {
    const routerLoaderClass = useRouteAnimation(disabledTransition);
    const mainWrapper = useRef();
    const minHeight = useMemo(() => {
        if (beforeHeaderRef?.current) {
            return `calc(100% - ${checkBrowser(beforeHeaderRef?.current?.getBoundingClientRect().height)}px)`;
        }
        return '100%';
    }, [beforeHeaderRef?.current]);

    return (
        <AuthExternal errorPage={errorPage}>
            <Language translates={translates} page={'/'}>
                <AuthModal />
                <div
                    {...(!errorPage ? { 'data-testid': 'loaded' } : {})}
                    style={{
                        minHeight: minHeight
                    }}
                    className={classNames(uikit.flexColumn, css.container)}
                >
                    {seoData || title || canonical || alias ? (
                        <SeoData data={seoData} title={title} canonical={canonical} alias={alias} />
                    ) : null}
                    <SingleHeader beforeHeaderRef={beforeHeaderRef} compStyles={compStyles} />
                    {breadcrumbs && <SingleBreadcrumbs compStyles={css} breadcrumbs={breadcrumbs} />}
                    <div
                        ref={mainWrapper}
                        className={classNames(
                            css.mainWrapper,
                            officeBg && css.officeWrapper,
                            compStyles?.mainWrapper,
                            routerLoaderClass
                        )}
                    >
                        {children}
                        {officeBg && (
                            <SingleFooter
                                officeBg={officeBg}
                                compStyles={compStyles}
                                OverFooter={OverFooter}
                                viewMoveUpBtn={viewMoveUpBtn}
                            />
                        )}
                    </div>
                    {!smallFooter && !officeBg && (
                        <SingleFooter compStyles={compStyles} OverFooter={OverFooter} viewMoveUpBtn={viewMoveUpBtn} />
                    )}
                    {/* <SingleUnderFooter /> */}
                </div>
            </Language>
        </AuthExternal>
    );
};
Single.propTypes = {
    title: PropTypes.string,
    smallFooter: PropTypes.bool,
    breadcrumbs: PropTypes.array,
    translates: PropTypes.object
};
export default Single;
